import React from 'react'
import {
  Grid,
  Box,
  Button
} from "@material-ui/core"
import { ideaEditStyles } from './IdeaEditStyles'
import Info from '@material-ui/icons/Info';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import dialogPhotoSvg from '../../assets/imgs/dialog-photo.svg';
import { EditUpload, EditUploadButton } from './../../components/Upload';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';

export const IdeaEditGeneralImage = () => {
  const classes = ideaEditStyles();

  return (
    <Grid item xs={12}>
      <Grid container spacing={3} className={classes.root}>
        <Grid item xs={12} className={classes.header}>
          <Box display='flex' alignItems='center'>
            <Box className={classes.iconHeader}>
              <PhotoCameraIcon color="primary" />
            </Box>
            <Box className={classes.titleCard}>imagens</Box>
          </Box>
          <EditUploadButton 
            type="photo"
            variant="text"
            text={"adicionar imagem"}
            icon={<AddCircleOutlinedIcon />}
          />
        </Grid>
        <Grid item xs={12}>
          <EditUpload
            type="photo"
            img={dialogPhotoSvg}
            name="foto"
            accept="image/png, image/jpeg"
            message=""
            maxSize={5242880}
          />
          <Box className={classes.info}>
            <Info style={{fontSize: 15, marginRight: 7 }}/>
            <p>
              O arquivo deve ser em formato <strong> png</strong> e<strong> jpg </strong> 
              e possuir tamanho máximo de<strong> 5mb</strong>.
            </p>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}
